import { axiosReq } from "@/lib/axios"
import { queryClient } from "@/lib/react-query" 
import { useMutation, useQuery } from "@tanstack/react-query"

export type ConfigFieldType = {
  id: number,
  name: string,
  endpoint: string,
  description: string,
  created_at: string,
  updated_at: string
}

export const useGetConfigs = () => {

  const request = async(): Promise<{
    api_configs: ConfigFieldType[]
  }> => {
    const response = await axiosReq.get('/api/landing/api-configs/')
    return response.data
  }

  const { data: configFieldsData, isLoading } = useQuery({
    queryKey: ["configs"],
    queryFn: request
  })

  return { configFieldsData, isLoading }

}

export type ConfigFieldArgumentType = Omit<ConfigFieldType, "id" | "created_at" | "updated_at">

export const useMutateField = () => {

  const request = async(data: ConfigFieldArgumentType) => {
    const response = await axiosReq.post('/api/landing/api-configs/', data);
    return response.data
  }

  const { mutate: mutateField, status } = useMutation({
    mutationFn: request,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["configs"]
      })
    }
  })

  return {  mutateField, status }
}

export const useDeleteConfigField = () => {
  
  const request = async(name: string) => {
    const response = await axiosReq.post('/api/landing/delete-configs/', {
      name
    })

    return response.data;
  }

  const { mutate: deleteField, status } = useMutation({
    mutationFn: request,
    onSuccess: () =>{
      queryClient.invalidateQueries({
        queryKey: ["configs"]
      })
    }
  })

  return { deleteField, status }
} 
